import React from 'react';
import ReactMarkdown from 'react-markdown';
import ReactMoment from 'react-moment';

import Menu from '../menu/menu.component';

import './terms-and-conditions.styles.scss';

type TermsAndConditionsProps = {
  content: string;
  lastModified: string;
};
const TermsAndConditions: React.FC<TermsAndConditionsProps> = ({
  content,
  lastModified,
}) => {
  return (
    <section className="terms-of-service ptb-100">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 col-md-12">
            <div className="terms-of-service-content">
              <img
                src={require('../../../assets/photos/terms-and-conditions.jpg')}
                alt="terms and conditions"
              />
              <p>
                <i>
                  This Privacy Policy was last updated on{' '}
                  <ReactMoment format="MMM Do YYYY">{lastModified}</ReactMoment>
                  .
                </i>
              </p>
              <ReactMarkdown source={content} allowDangerousHtml />
            </div>
          </div>

          <div className="col-lg-4 col-md-12">
            <Menu
              quickLinks={[
                { title: 'Who We Are', to: '/who-we-are' },
                { title: 'Contact', to: '/contact' },
                {
                  title: 'Privacy Policy',
                  to: '/privacy-policy',
                },
                {
                  title: 'Terms and Conditions',
                  to: '/terms-and-conditions',
                  active: true,
                },
              ]}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default TermsAndConditions;
